var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const ctx = self;
// This needs to be a dynamic import to be able to use the wasm from inside sourmash
let Signature = null;
let ComputeParameters = null;
const smImport = import('sourmash').then((Sourmash) => {
    Signature = Sourmash.Signature;
    ComputeParameters = Sourmash.ComputeParameters;
});
function sketchFiles(files, options) {
    for (const file of files) {
        sketchFile(file, options);
    }
}
function sketchFile(file, options) {
    return __awaiter(this, void 0, void 0, function* () {
        yield Promise.all([smImport]);
        const params = new ComputeParameters();
        params.set_ksizes(new Uint32Array([options.ksize]));
        params.set_scaled(options.scaled);
        params.set_num(options.num);
        params.set_protein(options.is_protein);
        params.set_dayhoff(options.dayhoff);
        params.set_hp(options.hp);
        params.set_track_abundance(options.track_abundance);
        params.set_seed(options.seed);
        const sig = new Signature(params);
        const cb = function (progress) {
            ctx.postMessage({
                type: 'progress:read',
                filename: file.name,
                progress: progress * 100,
            });
        };
        try {
            sig.add_from_file(file, cb);
        }
        catch (e) {
            ctx.postMessage({
                type: 'signature:error',
                filename: file.name,
                error: e.message,
            });
            return;
        }
        ctx.postMessage({
            type: 'signature:generated',
            filename: file.name,
            signature: sig.to_json(),
        });
    });
}
export default sketchFiles;
// Respond to message from parent thread
ctx.addEventListener('message', (event) => {
    var _a, _b;
    if ((_b = (_a = event === null || event === void 0 ? void 0 : event.data) === null || _a === void 0 ? void 0 : _a.files) === null || _b === void 0 ? void 0 : _b.length) {
        sketchFiles(event.data.files, event.data.options);
    }
});
